import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { login, logout } from '../containers/User/AuthSlice';

const styles = {
    root: {
        backgroundColor: '#191716',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100px',
        paddingBottom: '5px',
        display: 'flex',
        flexDirection: 'row',
        padding: '0 20px',
    },
    left: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'left',
        paddingBottom: '10px',
        width: '40%',
    },
    center: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'left',
        paddingBottom: '10px',
        width: '400px',
    },
    right: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'left',
        paddingBottom: '10px',
        width: '40%',
    },
    h1: {
        fontFamily: 'Oleo Script Swash Caps, sans-serif',
        color: '#E0E2DB',
        margin: 0,
        padding: 0,
        paddingTop: '10px',
        marginBottom: -20,
        justifyContent: 'center',
        alignItems: 'center',
    },
    h2: {
        color: '#ffcb77',
        fontSize: '1em',
        fontStyle: 'italic',
    },
    userContainer: {
        display: 'flex',
        alignItems: 'end',
        color: '#E0E2DB',
    },
    userInfo: {
        textAlign: 'end',
        marginRight: '20px',
        display: 'flex',
        flexDirection: 'column',
    },
    logoutLink: {
        color: '#ffcb77',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
};

export default function Header() {
    const user = useSelector((state) => state.auth.user);
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logout());
    };

    return (
        <div style={styles.root}>
            <div style={styles.left}></div>
            <div style={styles.center}>
                <h1 id='title' style={styles.h1}>
                    Disco de Vinil
                </h1>
                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                    <h2 style={styles.h2}>BACKOFFICE</h2>{' '}
                </div>
            </div>
            <div style={styles.right}>
                {user && (
                    <div style={styles.userContainer}>
                        <div style={styles.userInfo}>
                            <div>{user.name}</div>
                            <div>{user.email}</div>
                        </div>
                        <div style={styles.logoutLink} onClick={handleLogout}>
                            Logout
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
